import {primaryColor, webFont} from "../../config/theme";


export default {
    container: {
        padding: '20px 48px',
        maxWidth: '100%',
        borderRadius: 4,
        border: '1px solid #ff8000'

    },
    headerText: {
        fontSize: '26px',
        fontFamily: "Poppins",
        margin: '0 0 32px',
        fontWeight: 500,
        color: 'black',
    },
    labelText: {
        fontSize: "14px",
        fontWeight:500,
        fontFamily: webFont,
        margin: 0,
    },
    inputText: {
        fontSize: "18px",
        fontWeight:300,
        fontFamily: webFont
    },
    day: {
        height: 32,
        minWidth: 33,
        borderRadius: 24,
        margin: '0 9px 0 0',
        fontSize: "12px",
        fontFamily: webFont,
        textTransform: "capitalize"
    },
    daySelected: {
        height: 32,
        minWidth: 33,
        borderRadius: 24,
        margin: '0 9px 0 0',
        fontSize: "12px",
        fontFamily: webFont,
        color: "white",
        textTransform: "capitalize",
        boxShadow: 'none',
    },
    dayUnselected: {
        fontSize: "18px",
        fontFamily: webFont,
        color: primaryColor,
        textTransform: "capitalize",
        marginTop: 17
    },
    createButton: {
        borderRadius: 42,
        height: 42,
        lineHeight: 0.5,
        fontFamily: webFont,
        color: '#fff',
        minHeight: 49,
        width: '90%',
        margin: '35px auto 0'
    },
    cancelButton: {
        borderRadius: 42,
        height: 42,
        lineHeight: 0.5,
        fontFamily: webFont,
        minHeight: 49,
        width: '90%',
        margin: '0 auto'
    },

    createButtonText: {
        fontFamily: webFont,
        textTransform: "capitalize",
        fontSize: 18,
        lineHeight: "3px"
    },
    cancelButtonText: {
        fontFamily: webFont,
        textTransform: "capitalize",
        color: "black",
        fontSize: 18,
        opacity: "90%"
    }
};
